import React from 'react';
import { mapValues, noop, omit } from 'lodash';
import PropTypes from 'prop-types';
import { nucleusFormShape } from '../NucleusForm';
import missingNucleusFormError from '../utils/missingNucleusFormError';
const wrapInputWithActions = options => Component => {
    var _a;
    const displayName = `InputActions(${Component.displayName})`;
    return _a = class Validation extends React.Component {
            constructor(props, context) {
                super(props, context);
                this.createHandleEvent = (eventOptions, eventName) => {
                    return (...args) => {
                        const { [options.inputIdKey]: inputId, [eventName]: onEvent = noop } = this.props;
                        onEvent.apply(void 0, args);
                        if (eventOptions.eventType === 'change') {
                            this.nucleusForm.actions.changeInput(inputId);
                        }
                        else if (eventOptions.eventType === 'focus') {
                            this.nucleusForm.actions.focusInput(inputId);
                        }
                        else if (eventOptions.eventType === 'blur') {
                            this.nucleusForm.actions.blurInput(inputId);
                        }
                    };
                };
                this.nucleusForm = props.nucleusForm || context.nucleusForm;
                if (!this.nucleusForm) {
                    throw missingNucleusFormError(displayName);
                }
                this.eventHandlers = mapValues(options.events, this.createHandleEvent);
                this.nucleusForm.actions.addInput(props[options.inputIdKey]);
            }
            componentWillUnmount() {
                this.nucleusForm.actions.removeInput(this.props[options.inputIdKey]);
            }
            render() {
                return React.createElement(Component, Object.assign({}, omit(this.props, ['nucleusForm']), this.eventHandlers), this.props.children);
            }
        },
        _a.displayName = displayName,
        _a.contextTypes = {
            nucleusForm: nucleusFormShape
        },
        _a.propTypes = {
            [options.inputIdKey]: PropTypes.string.isRequired,
            children: PropTypes.node,
            nucleusForm: nucleusFormShape
        },
        _a;
};
export default wrapInputWithActions;
